<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-cards"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="3"
          md="3"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('Nombre')"
            hide-details
            single-line
            style="max-width: 400px;"
          />
        </v-col>
        <v-col
          cols="9"
          md="9"
          style="padding: 0px;"
        >
          <v-row>
            <v-col
              cols="3"
              md="3"
            >
              <v-select
                v-model="filter.gameLineId"
                :items="gameLines"
                item-text="name"
                item-value="id"
                label="Juego"
                @change="changeGame"
              />
            </v-col>
            <v-col
              cols="3"
              md="3"
            >
              <v-select
                v-model="filter.gameExpansionId"
                :items="gameExpansions"
                item-text="name"
                item-value="id"
                label="Expansión"
              />
            </v-col>
            <v-col
              cols="3"
              md="3"
            >
              <v-select
                v-model="filter.gameRarityId"
                :items="gameRarities"
                item-text="name"
                item-value="id"
                label="Rareza"
              />
            </v-col>
            <v-col
              cols="3"
              md="3"
            >
              <v-select
                v-model="filter.stockFlag"
                :items="stockOptions"
                item-text="name"
                item-value="id"
                label="Cartas stock"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :options.sync="options"
        :loading="loading"
        :server-items-length="totalRows"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-spacer />
            <v-btn
              class="mr-5 mb-0"
              elevation="1"
              color="warning"
              dark
              min-width="0"
              medium
              rounded
              :loading="loadingPokemon"
              @click="getCardsPokemon"
            >
              Pokemón<v-icon>mdi-sync</v-icon>
            </v-btn>
            <v-btn
              class="mr-5 mb-0"
              elevation="1"
              color="warning"
              dark
              min-width="0"
              medium
              rounded
              :loading="loadingMtg"
              @click="getCardsMtg"
            >
              Magic <v-icon>mdi-sync</v-icon>
            </v-btn>
            <v-btn
              class="mr-5 mb-0"
              elevation="1"
              color="warning"
              dark
              min-width="0"
              medium
              rounded
              :loading="loadingYugi"
              @click="getCardsYugi"
            >
              Yu-Gi-Oh! <v-icon>mdi-sync</v-icon>
            </v-btn>
            <v-btn
              elevation="1"
              color="primary"
              dark
              min-width="0"
              mediun
              rounded
              @click="addCard"
            >
              <v-icon>mdi-plus</v-icon>
              Nuevo
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.state`]="{ item }">
          {{ item.state ? "Activo": "Inactivo" }}
        </template>
        <template v-slot:[`item.priceCost`]="{ item }">
          {{ "$" + item.priceCost }}
        </template>
        <template v-slot:[`item.priceSell`]="{ item }">
          {{ "$" + item.priceSell }}
        </template>
        <template v-slot:[`item.cardName`]="{ item }">
          <router-link :to="{ name: 'card', params: { id: item.id }}">
            {{ item.cardName }}
          </router-link>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="editCard(item.id)">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.imagen`]="{ item }">
          <div v-if="item.apiImageUrl !== null">
            <v-btn
              color="success"
              class="px-1 ml-1 d-flex d-sm-none"
              fab
              x-small
            >
              <v-icon

                @click="showDialog(item.apiImageUrl)"
              >
                mdi-file-image
              </v-icon>
            </v-btn>
            <v-img
              class="d-none d-sm-flex"
              :lazy-src="item.apiImageUrl"
              max-height="100%"
              max-width="50px"
              :src="item.apiImageUrl"
              @click="showDialog(item.apiImageUrl)"
            />
          </div>
          <div v-else>
            Sin Imagen
          </div>
        </template>
      </v-data-table>
    </base-material-card>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="400"
        >
          <v-card>
            <v-img
              :lazy-src="dialogImage"
              :src="dialogImage"
              @click="dialog = false"
            />
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-snackbar
      v-model="showErrorMessage"
      top
      :multi-line="true"
      color="error"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="showSuccessMessage"
      top
      :multi-line="true"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSuccessMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const cardsRespository = repositoryFactory.get('cards')
  const gameRaritiesRepository = repositoryFactory.get('gameRarities')
  const gameLinesRepository = repositoryFactory.get('gameLines')
  // const gameExpansionsRepository = repositoryFactory.get('gameExpansions')

  export default {
    name: 'CardList',
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      showSuccessMessage: false,
      errorMessage: '',
      successMessage: '',
      totalRows: 0,
      options: { },
      filter: {
        stockFlag: false,
        gameLineId: null,
        gameExpansionId: null,
        gameRarityId: null,
      },
      stockOptions: [{ id: false, name: 'Todas' }, { id: true, name: 'Solo con stock' }],
      gameLines: [{ name: 'Todos', id: null, gameExpansion: [] }],
      gameExpansions: [{ name: 'Todas', id: null }],
      gameRarities: [{ name: 'Todas', id: null }],
      loadingMtg: false,
      loadingPokemon: false,
      loadingYugi: false,
      dialog: false,
      dialogImage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('cards')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.cards.code'),
            value: 'code',
          },
          {
            text: this.$t('tables.cards.name'),
            value: 'name',
          },
          {
            text: 'Imagen',
            value: 'imagen',
          },
          {
            text: 'Juego',
            value: 'gameLine.name',
          },
          {
            text: 'Expansión',
            value: 'gameExpansion.name',
          },
          {
            text: 'Rareza',
            value: 'rarity.name',
          },
          {
            text: this.$t('tables.cards.priceSell'),
            value: 'priceSell',
          },
          {
            text: this.$t('tables.cards.priceCost'),
            value: 'priceCost',
          },
          {
            text: this.$t('tables.cards.state'),
            value: 'state',
          },
          {
            text: this.$t('tables.cards.inventory'),
            value: 'inventory',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    watch: {
      options: {
        handler () {
          this.fetch()
        },
        deep: true,
      },
      search: {
        handler () {
          this.fetch()
        },
        deep: true,
      },
      filter: {
        handler () {
          this.fetch()
        },
        deep: true,
      },
    },
    mounted () {
      this.getGames()
      // this.fetch()
    },
    methods: {
      async fetch () {
        var self = this
        self.loading = true
        var data = {
          data: { name: this.search, gameExpansionId: self.filter.gameExpansionId, gameLineId: self.filter.gameLineId, rarityId: self.filter.gameRarityId, onlyStock: self.filter.stockFlag },
          page: this.options.page,
          pageSize: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
        }
        await cardsRespository.getCardsFiltered(data).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
            self.totalRows = response.data.totalRows
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      async getRarities (gameId) {
        var self = this
        await gameRaritiesRepository.getByGame(gameId).then(response => {
          response.data.data.map(function (item) {
            self.gameRarities.push(item)
          })
        }).catch(err => {
          alert(err)
        })
      },
      async getGames () {
        var self = this
        await gameLinesRepository.get().then(response => {
          response.data.data.map(function (item) {
            self.gameLines.push(item)
          })
        }).catch(err => {
          alert(err)
        })
      },
      addCard () {
        this.$router.push({ name: 'card', params: { id: 'add' } })
      },
      editCard (id) {
        this.$router.push({ name: 'card', params: { id: id } })
      },
      async changeGame () {
        var self = this
        self.filter.gameExpansionId = null
        self.filter.gameRarityId = null
        this.gameExpansions = [{ name: 'Todas', id: null, gameExpansion: [] }]
        if (this.filter.gameLineId !== null) {
          var game = this.gameLines.find(x => x.id === this.filter.gameLineId)
          game.gameExpansion.map(function (expansion) {
            self.gameExpansions.push(expansion)
          })
        }

        this.gameRarities = [{ name: 'Todas', id: null }]
        if (this.filter.gameLineId !== null) {
          await this.getRarities(this.filter.gameLineId)
        }

        // await this.fetch()
      },
      async getCardsMtg () {
        var self = this
        self.loadingMtg = true
        await cardsRespository.getCardsMtg().then(response => {
          self.loadingMtg = false
          console.log('getCardsMtg', response)
        }).catch(err => {
          self.loadingMtg = false
          self.errorMessage = err
          self.showErrorMessage = true
        })
      },
      async getCardsPokemon () {
        var self = this
        self.loadingPokemon = true
        await cardsRespository.getCardsPokemon().then(response => {
          self.loadingPokemon = false
          console.log('getCardsPokemon', response)
        }).catch(err => {
          self.loadingPokemon = false
          self.errorMessage = err
          self.showErrorMessage = true
        })
      },
      async getCardsYugi () {
        var self = this
        self.loadingYugi = true
        await cardsRespository.getCardsYugi().then(response => {
          self.loadingYugi = false
          console.log('getCardsYugi', response)
        }).catch(err => {
          self.loadingYugi = false
          self.errorMessage = err
          self.showErrorMessage = true
        })
      },
      get_url_extension (url) {
        return url ? url.split(/[#?]/)[0].split('.').pop().trim() : ''
      },
      showDialog (url) {
        this.dialog = true
        this.dialogImage = url
      },

    },
  }
</script>
